import { render, staticRenderFns } from "./educationInfos.vue?vue&type=template&id=5dd8bca0&scoped=true&"
import script from "./educationInfos.vue?vue&type=script&lang=ts&"
export * from "./educationInfos.vue?vue&type=script&lang=ts&"
import style0 from "./educationInfos.vue?vue&type=style&index=0&id=5dd8bca0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd8bca0",
  null
  
)

export default component.exports